import { SET_FILTER_MODEL } from "../../Redux/action.type";

export const setFilterModel = (data) => {
  return {
    type: SET_FILTER_MODEL,
    payload: data,
  };
};
